import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { Button } from '@/components/Shared/Button';
import { useContractImportStore, type ContractWizardStep } from '@/store/useContractImportStore';

interface Props {
  back?: ContractWizardStep;
  next?: ContractWizardStep;
  /** Extra summary text shown next to the buttons (e.g. "3 von 4 Positionen"). */
  summary?: string;
}

/** Mirror of the netzplan `StepFooter`, bound to the contract import store. */
export function ContractStepFooter({ back, next, summary }: Props) {
  const { t } = useTranslation('contractImport');
  const setStep = useContractImportStore((s) => s.setStep);
  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <div>
        {back && (
          <Button variant="secondary" leftIcon={<ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} />} onClick={() => setStep(back)}>
            {t('actions.back')}
          </Button>
        )}
      </div>
      <div className="flex items-center gap-3">
        {summary && <span className="text-[12px] text-slate-500">{summary}</span>}
        {next && (
          <Button rightIcon={<ArrowRight className="w-3.5 h-3.5" strokeWidth={2} />} onClick={() => setStep(next)}>
            {t('actions.next')}
          </Button>
        )}
      </div>
    </div>
  );
}

export default ContractStepFooter;
